/* eslint-disable lingui/no-unlocalized-strings */ const ErrorType = {
    Default: 'Default',
    EmailMagicLink: 'EmailMagicLink',
    Organization: 'Organization',
    CannotJoinOrgDueToAuthPolicy: 'CannotJoinOrgDueToAuthPolicy',
    AdBlockerDetected: 'AdBlockerDetected',
    OrganizationDiscoveryClaimedDomain: 'OrganizationDiscoveryClaimedDomain'
};

export { ErrorType };
//# sourceMappingURL=ErrorType.mjs.map
